import ViewProfile from './ViewProfile'
import EditProfile from './EditProfile'
import ViewTeam from './ViewTeam'
import EditTeam from './EditTeam'
import ViewAddresses from './ViewAddresses'
import EditAddresses from './EditAddresses'
import ViewBilling from './ViewBilling'
import EditBilling from './EditBilling'
import ViewApproval from './ViewApproval'
import EditApproval from './EditApproval'
import ViewEmails from './ViewEmails'
import EditEmails from './EditEmails'

export default [
  {
    key: 'profile',
    title: 'Profile',
    viewComponent: ViewProfile,
    editComponent: EditProfile
  }, {
    key: 'team',
    title: 'Team',
    viewComponent: ViewTeam,
    editComponent: EditTeam
  }, {
    key: 'addrs',
    title: 'Addresses',
    viewComponent: ViewAddresses,
    editComponent: EditAddresses
  }, {
    key: 'billing',
    title: 'Billing',
    viewComponent: ViewBilling,
    editComponent: EditBilling
  }, {
    key: 'approval',
    title: 'Approval',
    viewComponent: ViewApproval,
    editComponent: EditApproval,
  }, {
    key: 'emails',
    title: 'Emails',
    viewComponent: ViewEmails,
    editComponent: EditEmails,
    flag: 'enableEmailsSettings',
  }
];



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/settings/cards.js